var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.37 31.394l-5.375 3.84.768.767 4.607-4.607z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.587 35.282l.176.176 1.055-1.055-1.231.88zm4.56-4.2l.495.583-4.88 4.88-1.359-1.36 5.744-4.104z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.49 39.656l-1.219-.677a10.275 10.275 0 00-.047-10.238c-2.833-4.906-9.059-6.614-13.907-3.815-4.781 2.76-6.436 8.874-3.764 13.748l-1.197.69c-3.059-5.542-1.18-12.507 4.262-15.65 5.509-3.18 12.584-1.24 15.802 4.336a11.676 11.676 0 01.07 11.606z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.915 36.001a1.92 1.92 0 11-3.84 0 1.92 1.92 0 013.84 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/Measure.f766c18959de3a9c6bb0cea09d5545f7.svg";
export { ForwardRef as ReactComponent };